import {
  CategoryCollectionTypes,
  CategoryType,
  Product,
  Query,
  SearchResult,
  Shop,
} from '@prisjakt/search-types';
import flatMap from 'lodash/flatMap';
import { Suggestion } from './types';

export const getSuggestionsFromNewFormat = (
  data: SearchResult
): Suggestion[] => {
  let nextNavId = 1;
  return flatMap<keyof SearchResult['collections'], Suggestion>(
    data.collectionOrder,
    (collection: keyof SearchResult['collections']) => {
      switch (collection) {
        case 'suggestions':
          return data.collections[collection].items.map((i: Query) => ({
            // eslint-disable-next-line no-plusplus
            navId: nextNavId++,
            text: i.query,
            type: 'suggestion',
          }));
        case 'products':
          return data.collections[collection].items.map((i: Product) => ({
            // eslint-disable-next-line no-plusplus
            navId: nextNavId++,
            id: `${i.id}`,
            text: i.name,
            type: 'product',
            price: i.price?.regular || i.price?.alternative || 0,
          }));
        case 'shops':
          return data.collections[collection].items.map((i: Shop) => ({
            // eslint-disable-next-line no-plusplus
            navId: nextNavId++,
            id: `${i.id}`,
            text: i.name,
            type: 'store',
            logo: i.logoUrl,
          }));
        case 'categories': {
          return data.collections.categories.items.map(
            (i: CategoryCollectionTypes): Suggestion => {
              const shared = {
                // eslint-disable-next-line no-plusplus
                navId: nextNavId++,
                text: i.name,
                logo: i.logoName,
              };
              switch (i.type) {
                case CategoryType.BrandCategory:
                  return {
                    ...shared,
                    id: `b${i.brandId}-c${i.categoryId}`,
                    type: 'brand_category',
                  };
                case CategoryType.BrandVirtualCategory:
                  return {
                    ...shared,
                    id: `b${i.brandId}-v${i.virtualCategoryId}`,
                    type: 'brand_category',
                  };
                case CategoryType.Category:
                  return {
                    ...shared,
                    type: 'category',
                    id: `${i.categoryId}`,
                  };
                case CategoryType.OfferCollection:
                case CategoryType.ProductCollection:
                  return {
                    ...shared,
                    id: '',
                    type:
                      i.type === CategoryType.OfferCollection
                        ? 'offer_collection'
                        : 'product_collection',
                    meta: JSON.stringify({
                      url: i.url,
                      filters: i.filters,
                    }),
                  };
                case CategoryType.VirtualCategory:
                  return {
                    ...shared,
                    id: `v${i.virtualCategoryId}`,
                    type: 'vcategory',
                  };
                default:
                  throw new Error('Invalid category');
              }
            }
          );
        }
        default:
          return [];
      }
    }
  );
};
